var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCardTopUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 120 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #a3a3a2;\n      }\n\n      .cls-3 {\n        fill: none;\n      }\n\n      .cls-2, .cls-4 {\n        opacity: .5;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M92.6,43.6h-7.2v-4.8c0-2.3-1.9-4.2-4.2-4.2H27.2c-2.2,0-4,1.8-4,4v33.9c0,2.2,1.8,4,4,4h7.4v4.8c0,2.3,1.9,4.2,4.2,4.2h31.4c0-.3,0-.5,0-.8s0-.7,0-1h-31.4c0,0-.2,0-.2,0-.2,0-.5,0-.7-.2,0,0-.1,0-.2-.1-.2-.1-.4-.3-.6-.4-.4-.4-.7-1-.7-1.7v-33.5c0-1.3,1.1-2.4,2.4-2.4h53.9c1.3,0,2.4,1.1,2.4,2.4v11.1c.3,0,.6,0,1,0s.6,0,.8,0v-11.1c0-2.3-1.9-4.2-4.2-4.2ZM34.5,74.7h-7.4c-1.2,0-2.2-1-2.2-2.2v-16.8h9.6v19ZM83.6,43.6h-44.9c-.4,0-.8,0-1.2.2h-12.5v-5.2c0-1.2,1-2.2,2.2-2.2h54.1c1.3,0,2.4,1.1,2.4,2.4v4.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M42.3,58.1v.2c0,.9.7,1.5,1.5,1.5h9.4c.5,0,1-.3,1.3-.7.2-.2.3-.6.3-.9v-.2h-12.5ZM42.3,58.1v.2c0,.9.7,1.5,1.5,1.5h9.4c.5,0,1-.3,1.3-.7.2-.2.3-.6.3-.9v-.2h-12.5ZM42.3,58.1v.2c0,.9.7,1.5,1.5,1.5h9.4c.5,0,1-.3,1.3-.7.2-.2.3-.6.3-.9v-.2h-12.5ZM42.3,58.1v.2c0,.9.7,1.5,1.5,1.5h9.4c.5,0,1-.3,1.3-.7.2-.2.3-.6.3-.9v-.2h-12.5ZM42.3,58.1v.2c0,.9.7,1.5,1.5,1.5h9.4c.5,0,1-.3,1.3-.7.2-.2.3-.6.3-.9v-.2h-12.5ZM42.3,58.1v.2c0,.9.7,1.5,1.5,1.5h9.4c.5,0,1-.3,1.3-.7.2-.2.3-.6.3-.9v-.2h-12.5ZM42.3,58.1v.2c0,.9.7,1.5,1.5,1.5h9.4c.5,0,1-.3,1.3-.7.2-.2.3-.6.3-.9v-.2h-12.5ZM42.3,58.1v.2c0,.9.7,1.5,1.5,1.5h9.4c.5,0,1-.3,1.3-.7.2-.2.3-.6.3-.9v-.2h-12.5ZM42.3,58.1v.2c0,.9.7,1.5,1.5,1.5h9.4c.5,0,1-.3,1.3-.7.2-.2.3-.6.3-.9v-.2h-12.5ZM42.3,58.1v.2c0,.9.7,1.5,1.5,1.5h9.4c.5,0,1-.3,1.3-.7.2-.2.3-.6.3-.9v-.2h-12.5ZM42.3,58.1v.2c0,.9.7,1.5,1.5,1.5h9.4c.5,0,1-.3,1.3-.7.2-.2.3-.6.3-.9v-.2h-12.5ZM42.3,58.1v.2c0,.9.7,1.5,1.5,1.5h9.4c.5,0,1-.3,1.3-.7.2-.2.3-.6.3-.9v-.2h-12.5ZM42.3,58.1v.2c0,.9.7,1.5,1.5,1.5h9.4c.5,0,1-.3,1.3-.7.2-.2.3-.6.3-.9v-.2h-12.5ZM42.3,58.1v.2c0,.9.7,1.5,1.5,1.5h9.4c.5,0,1-.3,1.3-.7.2-.2.3-.6.3-.9v-.2h-12.5ZM42.3,58.1v.2c0,.9.7,1.5,1.5,1.5h9.4c.5,0,1-.3,1.3-.7.2-.2.3-.6.3-.9v-.2h-12.5ZM42.3,58.1v.2c0,.9.7,1.5,1.5,1.5h9.4c.5,0,1-.3,1.3-.7.2-.2.3-.6.3-.9v-.2h-12.5ZM42.3,58.1v.2c0,.9.7,1.5,1.5,1.5h9.4c.5,0,1-.3,1.3-.7.2-.2.3-.6.3-.9v-.2h-12.5ZM42.3,58.1v.2c0,.9.7,1.5,1.5,1.5h9.4c.5,0,1-.3,1.3-.7.2-.2.3-.6.3-.9v-.2h-12.5ZM42.3,58.1v.2c0,.9.7,1.5,1.5,1.5h9.4c.5,0,1-.3,1.3-.7.2-.2.3-.6.3-.9v-.2h-12.5ZM42.3,58.1v.2c0,.9.7,1.5,1.5,1.5h9.4c.5,0,1-.3,1.3-.7.2-.2.3-.6.3-.9v-.2h-12.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 41.8,
    y: 72.7,
    width: 9.9,
    height: 3.8
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 41.8,
    y: 65,
    width: 26.9,
    height: 3.8
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 42.3,
    y: 52.5,
    width: 3.1,
    height: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.8,51.3v.3h-12.5v-.3c0-.9.7-1.5,1.6-1.5h9.4c.9,0,1.6.7,1.6,1.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 51.7,
    y: 52.5,
    width: 3.1,
    height: 4.7
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M54.8,58.1v.2c0,.9-.7,1.5-1.6,1.5h-9.4c-.9,0-1.6-.7-1.6-1.5v-.2h12.5Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 46.3,
    y: 52.5,
    width: 4.5,
    height: 4.7
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "107 101.4 105.1 101.4 105.1 95.7 99.4 95.7 99.4 93.8 105.1 93.8 105.1 88.1 107 88.1 107 93.8 112.7 93.8 112.7 95.7 107 95.7 107 101.4"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.7,72.9l-.5-.6c-.1-.2-3.2-3.9-11.2-3.9s-11,3.7-11.1,3.9l-.5.6v19.8s.2.2.2.2c.1.2,3,3.5,11,3.7h.9c-.1-.6-.2-1.3-.2-1.9,0-2.3.8-4.4,2.1-6.1-.2,0-.4,0-.7,0-1.1,0-2.2,0-3.2,0v-4.9c.5,0,1,0,1.5,0,.9,0,1.8,0,2.7-.2v4.6c.5-.6,1.1-1.1,1.8-1.6v-3.3c1.7-.4,3.5-1,5.4-2v3.6h.1c.5,0,1,0,1.5.1h.1v-12.1h0ZM86.1,74.4c.8.5,2,1.1,3.6,1.7v4.9c-1.8-.6-3-1.4-3.6-1.8v-4.8ZM92.7,83.5v4.9c-1.1-.2-2.1-.5-3-.8v-4.9c.9.3,1.9.6,3,.7ZM86.1,81.3c.5.3,1.1.6,1.8.9v4.9c-.8-.4-1.4-.7-1.8-.9v-4.8ZM89.7,94c-2.1-.7-3.2-1.5-3.6-1.9v-3.9c.9.4,2.1,1,3.6,1.5v4.4ZM95.5,90.5v4.3c-1.5,0-2.9-.2-4-.4v-4.4c1.2.3,2.6.5,4,.5ZM95.7,82.1c-1.5,0-2.9-.2-4.1-.5v-5c1.2.3,2.6.4,4.1.5v5.1ZM86.9,72.8c1.2-.9,3.9-2.5,9-2.5s7.9,1.6,9.1,2.5c-1.4.9-4.4,2.4-9,2.4s-7.7-1.6-9.1-2.4ZM101.3,81.2c-1.3.4-2.6.6-3.8.7v-5.1c1.4,0,2.7-.3,3.8-.6v4.9ZM105.9,79.3c-1,.5-1.9,1-2.8,1.4v-4.9c1.2-.4,2.1-1,2.8-1.4v4.9Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardTopUp);
export default __webpack_public_path__ + "static/media/credit-card-top-up.7683ec68d420658747601b35318dc8e9.svg";
export { ForwardRef as ReactComponent };